import { useCallback } from "react";

import type { OptionPmsColorItemInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Query from "../../query";
import * as Schema from "../schema";

export const useOptionPmsColorItemUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(Schema.OPTION_PMS_COLOR_ITEM_UPDATE_FOR_OPTION_PMS_MUTATION);

	const onUpdateOptionPmsColorItemUpdate = useCallback(
		async (input: OptionPmsColorItemInput) =>
			mutationFunc({
				variables: { input },
				refetchQueries: [Query.Schema.OPTION_PMS_COLOR_LIST_FOR_OPTION_PMS],
			}),
		[mutationFunc],
	);

	return { onUpdateOptionPmsColorItemUpdate };
};
